export default __webpack_public_path__ + "d94aa4c5861531113bf6f70cb13d766c.png";